import MUIAlertTitle, { AlertTitleProps } from "@mui/material/AlertTitle";
import styled from "@mui/material/styles/styled";

const AlertTitle = styled(MUIAlertTitle)<AlertTitleProps>(({ theme }) => ({
    ...(theme.typography.subtitle1 ?? {}),
}));

export default AlertTitle;
